import { ChangeEvent } from 'react';

/**
 * Adjusts the cursor position inside an input field based on the value changes.
 * @param event - The event object triggered by the input change.
 * @param formattedValue - The updated formatted value in the input field.
 * @param originalValue - The original value before formatting in the input field.
 */
export const adjustInputCursor = (
  event: ChangeEvent<HTMLInputElement>,
  formattedValue: string,
  originalValue: string
) => {
  const caret =
    formattedValue.length -
    (originalValue.length ?? 0) +
    (event.target.selectionStart ?? 0);

  window.requestAnimationFrame(() => {
    event.target.selectionStart = caret;
    event.target.selectionEnd = caret;
  });
};
